import React from 'react';
import { Spacer } from '@ontruck/orc';
import { OrderLink } from './idLink';

const xDockRenderer = ({
  changes: { auxiliary_shipper_order_ids, shipper_order_id: parentShipperOrderId },
  shipperOrderId: originalShipperOrderId,
  ...props
}) => {
  const auxiliaryIds = auxiliary_shipper_order_ids || [];

  if (originalShipperOrderId === parentShipperOrderId) {
    return (
      <Spacer {...props}>
        Auxiliary:{' '}
        {auxiliaryIds.map((id) => (
          <OrderLink id={id} key={id} />
        ))}
      </Spacer>
    );
  }

  return (
    <Spacer {...props}>
      Parent: <OrderLink id={parentShipperOrderId} />
    </Spacer>
  );
};

export default xDockRenderer;
